/* @flow */

import React from 'react';
import styled from 'styled-components';
import FlexBox from '../../../components/FlexBox';

const CountDownBox = styled(FlexBox)`
  justify-content: center;
  margin: 16px auto;

  > span {
    flex: none;
    width: 80px;
    height: 100px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
    line-height: 42px;
    margin: 0 15px;
    flex-wrap: wrap;
    color: rgba(255,255,255,${({ isEnding }) => (isEnding ? 0.3 : 1)});
    flex-direction: column;
    font-family: ${({ theme }) => theme.fontIBMMedium};
    
    > i {
      font-style: normal;
      font-size: 14px;
      margin-top: 5px;
      line-height: 20px;
      font-family: ${({ theme }) => theme.fontIBMRegular};
      color: rgba(255,255,255,0.3);
    }
  }
  
  @media screen and (max-width: 414px) {
    > span {
      width: 48px;
      height: 60px;
      font-size: 20px;
      flex-direction: row;
      flex-wrap: wrap;
      padding-bottom: 6px;
      margin: 0 7px;
      
      > i {
        width: 100%;
        font-size: 12px;
        margin-top: -10px;
      }
    }
  }
`;

type Props = {
  seconds: number,
  language: Object,
  onCountDownEnd: Function,
  isEnding: boolean,
};

type State = {
  D: string | number,
  H: string | number,
  M: string | number,
  S: string | number,
};

export default class CountDown extends React.Component<Props, State> {
  static defaultProps = {
    onCountDownEnd: () => window.location.reload(),
    language: { },
    seconds: 600,
    isEnding: false,
  };

  constructor(props: Props) {
    super(props);
    this.state = this.convertSec(props.seconds);
  }

  componentDidMount() {
    this.countDown(this.props.seconds);
  }

  componentWillReceiveProps(nextProps) {
    const { seconds } = this.props;
    const { seconds: nextSeconds } = nextProps;
    if (seconds !== nextProps) this.countDown(nextSeconds);
  }

  clearTime = () => {
    if (this.$timer !== null) {
      clearTimeout(this.$timer);
      this.$timer = null;
    }
  }

  countDown = (seconds) => {
    if (seconds <= 0) return;
    this.clearTime();
    this.$timer = setInterval(() => {
      seconds--;
      if (seconds < 0) {
        this.clearTime();
        this.props.onCountDownEnd();
      } else this.setState(this.convertSec(seconds));
    }, 1000);
  }

  convertSec = (seconds: number): State => {
    const d = Math.floor(seconds / 24 / 3600) || 0;
    const h = Math.floor((seconds / 3600) % 24) || 0;
    const m = Math.floor((seconds / 60) % 60) || 0;
    const s = Math.floor(seconds % 60) || 0;
    return ({
      D: d > 9 ? d : `0${d}`,
      H: h > 9 ? h : `0${h}`,
      M: m > 9 ? m : `0${m}`,
      S: s > 9 ? s : `0${s}`,
    });
  };

  render() {
    const {
      props: { language = { }, isEnding },
      state: {
        D, H, M, S,
      },
    } = this;
    return (
      <CountDownBox isEnding={isEnding}>
        <span>{D}<i>{ language.D || '天'}</i></span>
        <span>{H}<i>{ language.H || '时'}</i></span>
        <span>{M}<i>{ language.M || '分'}</i></span>
        <span>{S}<i>{ language.S || '秒'}</i></span>
      </CountDownBox>
    );
  }
}
